import { COLORS, hexToRGB } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const Wrapper = styled('div')<{ isShow?: boolean }>`
    position: absolute;
    display: ${({ isShow }) => (isShow ? 'flex' : 'none')};
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    transition: opacity 0.1s ease;
    background-color: ${hexToRGB(COLORS.neutral_00, 0.6)};
    opacity: ${({ isShow }) => Number(isShow)};
    pointer-events: ${({ isShow }) => (isShow ? 'unset' : 'none')};
`;
